
import { Component, Vue } from 'vue-property-decorator';
import { Plotly } from 'vue-plotly';
import { ChartActions } from '@/store/actions/charts';
import BarChart from '@/components/DataTab/Charts/ChartComponents/BarChart.vue';
import { ChartReturnType, PlotlyTraceType } from '@/types';
import { txtwrapper } from '@/helpers/txtwrapper';
import { colors } from '@/assets/colors/colors';

@Component({ components: { Plotly, BarChart } })
export default class Plot11 extends Vue {
  mounted() {
    this.$store.dispatch(ChartActions.CHART_REQUEST, {
      chartId: this.selectedChart,
      basinId: this.selectedArea.id,
    });
  }

  chartSelection = 'wet';

  radioGroup = [
    {
      label: this.$t(`data.chartTables.${this.selectedChart}.options.wet`),
      value: 'wet',
    },
    {
      label: this.$t(`data.chartTables.${this.selectedChart}.options.dry`),
      value: 'dry',
    },
    {
      label: this.$t(`data.chartTables.${this.selectedChart}.options.avg`),
      value: 'avg',
    },
  ];

  get chartData() {
    const initialData = [
      {
        x: [],
        y: [],
        name: this.$t(
          `data.chartTables.${this.selectedChart}.traceItems.tealText`,
        ),
        type: 'bar',
        marker: {
          color: colors.teal,
        },
      },
      {
        x: [],
        y: [],
        name: this.$t(
          `data.chartTables.${this.selectedChart}.traceItems.purpleText`,
        ),
        type: 'bar',
        marker: {
          color: colors.purple,
        },
      },
    ];

    initialData.forEach((object: PlotlyTraceType) => {
      this.scenarioList.forEach((scenario: string) => {
        object.x.push(this.$t(`scenarioNames.${scenario}`) as string);
        const found = this.chartReturn.find(
          (item: ChartReturnType) => item.scenario === scenario,
        );
        if (
          found?.iwr &&
          object.name ===
            this.$t(
              `data.chartTables.${this.selectedChart}.traceItems.purpleText`,
            )
        ) {
          object.y.push(found.iwr);
        } else if (
          object.name ===
            this.$t(
              `data.chartTables.${this.selectedChart}.traceItems.tealText`,
            ) &&
          found?.inefficiencies_wet &&
          found?.inefficiencies_dry &&
          found?.inefficiencies_avg
        ) {
          this.chartSelection === 'wet'
            ? object.y.push(found.inefficiencies_wet)
            : this.chartSelection === 'dry'
            ? object.y.push(found.inefficiencies_dry)
            : object.y.push(found.inefficiencies_avg);
        }
      });
    });

    return txtwrapper(initialData);
  }

  get chartReturn(): ChartReturnType[] {
    return this.$store.getters.data;
  }

  get scenarioList() {
    return this.$store.getters.selectedScenarioList;
  }

  get selectedArea() {
    return this.$store.getters.selectedArea;
  }

  get selectedChart() {
    return this.$store.getters.selectedChart;
  }
}
